export type TherapyFilters = {
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
  status: string;
  paymentStatus: string;
  payoutStatus: string;
};

/** `booked`: najnovije rezervisano prvo (default), `scheduled`: najkasniji termin prvo. */
export type TherapySort = "booked" | "scheduled";

export const ITEMS_PER_PAGE = 20;
